import type React from 'react';
import { Archive, Bot, Lightbulb, LineChart, Scale, ScanLine, Sparkles, Swords } from 'lucide-react';

/** Icon per feature page (featurePages.json `icon`). */
const FEATURE_ICONS: Record<string, React.ElementType> = { LineChart, Scale, ScanLine, Bot, Swords, Archive, Lightbulb };

export const featureIcon = (name: string): React.ElementType => FEATURE_ICONS[name] || Sparkles;
